// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aFk0zCwvKi1ld56hgYhF{max-width:180px;margin-top:16px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/doubleOptIn/ui/doubleOptInSettingAutoCloseAdditional/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CACA,eAAA","sourcesContent":[".wrap {\n  max-width: 180px;\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `aFk0zCwvKi1ld56hgYhF`
};
export default ___CSS_LOADER_EXPORT___;
